// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1435":"a63b4e28","4596":"89ea3ceb","5041":"41ec58f6","7718":"ec356b03","9348":"cf003a15"}[chunkId] + ".chunk.css";
};